import { render } from "./access-planner-guard.vue?vue&type=template&id=48218b48&scoped=true&ts=true"
import script from "./access-planner-guard.vue?vue&type=script&lang=ts"
export * from "./access-planner-guard.vue?vue&type=script&lang=ts"

import "./access-planner-guard.vue?vue&type=style&index=0&id=48218b48&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48218b48"]])

export default __exports__